export default "__VITE_ASSET__CD0zdfsR__"